<script setup>
import { X } from "lucide-vue-next";
import { Motion } from "motion-v";
const props = defineProps({
  modalValue: { type: Boolean, required: true },
  title: String,
  width: {
    type: String,
    default: "w-full sm:w-[600px]", // largura padrão
  },
  height: {
    type: String,
    default: "max-h-full sm:max-h-[90vh]", // altura padrão
  },
});

const emit = defineEmits(["update:modalValue"]);

const closeModal = () => emit("update:modalValue", false);
</script>

<template>
  <Motion
    v-if="modalValue"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    :initial="{ opacity: 0 }"
    :animate="{ opacity: 1 }"
    :exit="{ opacity: 0 }"
  >
    <Motion
      :class="[width, height]"
      class="relative flex flex-col bg-white shadow-lg rounded-lg overflow-hidden"
      :initial="{ scale: 0.8, opacity: 0 }"
      :animate="{ scale: 1, opacity: 1, transition: { duration: 0.3 } }"
      :exit="{ scale: 0.8, opacity: 0, transition: { duration: 0.2 } }"
    >
      <div
        class="flex items-center justify-between p-2 border-b border-gray-200"
      >
        <h3 class="text-lg font-medium text-gray-900">
          {{ props.title }}
        </h3>
      </div>

      <button
        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center absolute top-3.5 right-3.5"
        @click="closeModal"
      >
        <X class="w-5 h-5" />
      </button>
      <div
        class="flex-1 overflow-visible sm:overflow-y-auto max-h-full sm:max-h-[80vh] custom-scrollbar p-4"
      >
        <slot />
      </div>
    </Motion>
  </Motion>
</template>